import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-accac1b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 5 }
const _hoisted_8 = { key: 6 }
const _hoisted_9 = { key: 7 }
const _hoisted_10 = { key: 8 }

import { reactive, onMounted, toRefs, UnwrapRef, toRaw } from 'vue'
import patientView from "../patient/patientView.vue";
import { useRoute } from 'vue-router';
import { getCaseInfo } from '@/api/patient';
import { getDate } from '@/components/ts/components';
import trackOrderView from "@/views/order/trackOrder/trackOrderView.vue";
import oralDetection from "@/views/order/oralDetection/detailTable.vue";
import oralFace from "@/views/order/oralFace/detailTable.vue";
import oralDiagnosis from "@/views/order/oralDiagnosis/detailTable.vue";
import designingScheme from "@/views/order/designingScheme/index.vue";
import saleOrder from "@/views/order/saleOrder/detailTable.vue";
import appointment from "@/views/order/appointment/detailTable.vue";
import MonitorUseSituation from "@/views/order/oralDetection/monitorUseSituation.vue";
import ProcesshHistory from "./processhHistory.vue";

interface Data {
  patientId: string | undefined,
  patientType: string,
  doctorId: number,
  hospitalId: number,
  noTitleKey: string,
  patientInfo: {
    name: string;
    mobile: string;
    gender: string;
    idNumber: string;
    born: string;
    email: string;
    docs: any[]
  },
  hospitalInfo: {
    shortName: string;
    fullName: string;
    license: string;
    type: string;
    tel: string;
    areaId: string;
    address: string;
  },
  doctorInfo: {
    name: string;
    email: string;
    mobile: string;
    gender: string;
    born: string;
    idNumber: string;
    level: string,
    license: string,
    docs: any[]
  },
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PatientDetail',
  setup(__props) {

const route = useRoute();

const data: UnwrapRef<Data> = reactive({
  patientId: '',
  patientType: "update",
  doctorId: 0,
  hospitalId: 0,
  noTitleKey: "1",
  patientInfo: {
    name: "",
    mobile: "",
    gender: "",
    idNumber: "",
    born: "",
    email: "",
    docs: [],
  },
  hospitalInfo: {
    shortName: "",
    fullName: "",
    license: "",
    type: "",
    tel: "",
    areaId: "",
    address: "",
  },
  doctorInfo: {
    born: '',
    email: "",
    name: "",
    gender: "",
    idNumber: "",
    lastName: '',
    mobile: "",
    level: '',
    license: '',
    docs: []
  },
})

onMounted(() => {
  getCaseInfo(route.query.id).then((res: any) => {
    console.log(res);
    if (res.type == 0) {
      patientInfo.value = res.leadsBo
      patientInfo.value.firstName = res.leadsBo.name
      patientInfo.value.mobile = res.leadsBo.mobile
      patientId.value = res.leadsBo.id
    } else {
      patientInfo.value = res.sysUserPatientBo
      patientInfo.value.born = res.sysUserPatientBo.born ? getDate(res.sysUserPatientBo.born) : '';
      patientInfo.value.docs = res.sysUserPatientBo.docs ? res.sysUserPatientBo.docs : [];
      console.log(toRaw(patientInfo.value));
      patientId.value = res.sysUserPatientBo.id
      // onSearchDentist(res.id)
    }
  })
})

const tabListNoTitle = [
  {
    key: "1",
    tab: '销售订单',
  },
  // {
  //   key: "2",
  //   tab: '医院',
  // },
  {
    key: "3",
    tab: '口腔拍摄订单',
  },
  {
    key: "4",
    tab: '面部照订单',
  },
  {
    key: "5",
    tab: '口腔诊断订单',
  },
  {
    key: "6",
    tab: '正畸设计订单',
  },
  {
    key: "7",
    tab: '治疗追踪订单',
  },
  // {
  //   key: "8",
  //   tab: '销售订单',
  // },
  {
    key: "9",
    tab: '预约订单',
  },
  // {
  //     key: "10",
  //     tab: '监护仪使用情况',
  // },
  {
    key: "11",
    tab: '流程历史',
  },
];
const onTabChange = (value: string) => {
  noTitleKey.value = value;
  // if (value == "1") {
  //   onSearchDentist(data.patientId)
  // } else if(value == '2'){
  //   onSearchClinic(data.patientId)
  // }else {
  //   onSearchClinic(data.patientId)
  // }
};

const {
  patientId,
  noTitleKey,
  patientInfo,
} = toRefs(data)

return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "个人信息" }, {
      default: _withCtx(() => [
        _createVNode(patientView, { patientInfo: _unref(patientInfo) }, null, 8, ["patientInfo"])
      ]),
      _: 1
    }),
    _hoisted_1,
    _createVNode(_component_a_card, {
      style: {"width":"100%"},
      "tab-list": tabListNoTitle,
      "active-tab-key": _unref(noTitleKey),
      onTabChange: _cache[0] || (_cache[0] = (key) => onTabChange(key))
    }, {
      default: _withCtx(() => [
        (_unref(noTitleKey) === '1')
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
              _createVNode(saleOrder)
            ]))
          : (_unref(noTitleKey) === '3')
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                _createVNode(oralDetection)
              ]))
            : (_unref(noTitleKey) === '4')
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                  _createVNode(oralFace)
                ]))
              : (_unref(noTitleKey) === '5')
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                    _createVNode(oralDiagnosis)
                  ]))
                : (_unref(noTitleKey) === '6')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                      _createVNode(designingScheme, {
                        "patient-id": data.patientId
                      }, null, 8, ["patient-id"])
                    ]))
                  : (_unref(noTitleKey) === '7')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                        _createVNode(trackOrderView, { id: _unref(patientId) }, null, 8, ["id"])
                      ]))
                    : (_unref(noTitleKey) === '9')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                          _createVNode(appointment)
                        ]))
                      : (_unref(noTitleKey) === '10')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                            _createVNode(MonitorUseSituation, { "related-id": _unref(patientId) }, null, 8, ["related-id"])
                          ]))
                        : (_unref(noTitleKey) === '11')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                              _createVNode(ProcesshHistory, {
                                "patient-id": data.patientId
                              }, null, 8, ["patient-id"])
                            ]))
                          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["active-tab-key"])
  ]))
}
}

})